import axios from 'axios';

export const API_GET_SAVED_JOBS = '/api/community/jobbing/saved-jobs';
export const API_SEARCH_JOBS = '/api/community/jobbing/search';
export const API_SEARCH_JOB = '/api/community/jobbing/single-job-search';
export const API_FOLLOW_JOB = '/api/user/alerts/job/follow';
export const API_UNFOLLOW_JOB = '/api/user/alerts/job/unfollow';
const API_COMMUNITY_VOTES_CONTENT =
    '/api/community/community-votes/attribute/contents';
const API_SAVE_JOB = '/api/community/community-votes/vote/jobbing';
const API_UNSAVE_JOB = '/api/community/community-votes/unvote/jobbing';

/**
 * Toggle Job Save Function
 * @param {Object} ToggleJobParams
 * @param {boolean} ToggleJobParams.userLiked has user saved this job
 * @param {string} ToggleJobParams.hash job slug
 */
export const toggleJobSave = async ({ userLiked, hash }) => {
    const url = userLiked ? API_UNSAVE_JOB : API_SAVE_JOB;
    try {
        await axios.post(url, {
            type: 'like',
            hash_id: hash,
            value: 1,
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
};

/**
 * Get saved jobs for users
 * @param {Object} CommunityContentParams
 * @param {Object[]} CommunityContentParams.content has user saved this job
 * @param {string} CommunityContentParams.content[].hash has user saved this job
 */
export const getCommunityContent = async ({ content }) => {
    try {
        const contentArray = content.map((c) => ({
            commentHashes: [],
            contentType: 'jobbing',
            hash: c.hash,
        }));

        const response = (
            await axios.post(API_COMMUNITY_VOTES_CONTENT, {
                contentArray,
            })
        ).data;
        if (!Array.isArray(response)) return content;
        const responseHashMap = {};

        response?.forEach((j) => {
            responseHashMap[j.hash] = {
                userLiked: j.voteTypes.indexOf('like') > -1,
            };
        });

        const _content = content.map((c) => ({
            ...c,
            ...responseHashMap[c.hash],
        }));

        return _content;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return content;
    }
};

export const unfollowJobAlert = async ({ notificationId }) => {
    try {
        const res = await axios.post(API_UNFOLLOW_JOB, {
            notificationId,
        });
        return res?.data;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

/**
 * Add a job alert
 * @param {Object} FollowJobAlertParams
 * @param {string} FollowJobAlertParams.jobSearchTerm Job search keywords
 * @param {string} FollowJobAlertParams.jobLocation Job location
 * @param {number} FollowJobAlertParams.jobLng lattitude
 * @param {number} FollowJobAlertParams.jobLat longitude
 */
export const followJobAlert = async ({
    jobSearchTerm,
    jobLocation,
    jobLng,
    jobLat,
}) => {
    try {
        const res = await axios.post(API_FOLLOW_JOB, {
            jobSearchTerm,
            jobLocation,
            jobLng,
            jobLat,
        });
        return res?.data;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

/**
 * Add a job alert
 * @param {Object}
 * @param {number} [page] Page number to get
 * @param {number} [limit] Job location
 */
export const searchJobs = async (url) => {
    try {
        const res = await axios.get(url);
        const { jobs, total, facets, queryID } = res.data;

        return { jobs, total, facets, queryID };
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

/**
 * Get single job data
 * @param {Object} SingleJobParams
 * @param {string} SingleJobParams.url Job search query
 */
export const searchSingleJob = async ({ url }) => {
    try {
        const res = await axios.get(`${API_SEARCH_JOB}/${url}`);
        const { jobDetails } = res.data;
        return jobDetails;
    } catch (err) {
        return null;
    }
};
